import { render, staticRenderFns } from "./AddCategoryForm.vue?vue&type=template&id=116ef4d4&scoped=true&"
import script from "./AddCategoryForm.vue?vue&type=script&lang=js&"
export * from "./AddCategoryForm.vue?vue&type=script&lang=js&"
import style0 from "./AddCategoryForm.vue?vue&type=style&index=0&id=116ef4d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116ef4d4",
  null
  
)

export default component.exports